

export const getPendientes = async() => {

    const server_url=  process.env.REACT_APP_PRODUCCION;  
    console.log(server_url)


    const entidad= localStorage.getItem('entidad') || null;

    if( entidad === null ) return [];


    const resp = await fetch(`${server_url}/pendientes/${entidad}`);
    const data = await resp.json();

    return(data.pendientes);

}